import { requestService as api } from "./Request.service"  

const API_URL = {
  API_MANAGE: `/treatment/manage.php`,
  API_SEARCH: `/treatment/search.php`,
  API_DETAIL: `/treatment/get_detail.php`,
};



const TreatmentService = () => { 
 
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);
  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});
  const getdetail = (code) => api.get(`${API_URL.API_DETAIL}?code=${code}`);

  return {
    create,
    update,
    deleted,
    get,
    search,
    getdetail,

  };
};

export default TreatmentService;
